module.exports = __webpack_public_path__ + "img/pdf_icon.c9b13a13.svg";